export enum ReportType {
	Complaint = 1,
	Rasff = 2,
}
